<template>
  <div class="layout">
    <div class="flex flex-row f6" :class="[bg === 'light' ? 'bg-light' : 'bg-middle']">
      <input v-model="input"
        class="text-input" :class="[bg === 'light' ? 'bg-light' : 'bg-middle']" id="document_template_search_field"
        :placeholder="placeholder"
        @keydown.enter.prevent="search"
      />
      <button v-if="input"  @click="reset" class="input-icon-button bg-input-button" id="document_template_search_reset_button">
        <font-awesome-icon icon="times" />
      </button>
    </div>
    <button  @click="search" class="button primary" id="document_template_search_button">
      Найти
    </button>
  </div>
</template>

<script>
export default {
  props: {
    initValue: String,
    placeholder: String,
    bg: { default: 'light' }
  },
  data () {
    return {
      input: this.initValue
    }
  },
  watch: {
    input: {
      immediate: false,
      handler: function (value) {
        if (!value) {
          this.reset()
        }
      }
    }
  },
  methods: {
    search () {
      this.$emit('search', this.input)
    },
    reset () {
      this.input = null
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: 1fr 130px;
  grid-template-rows: auto;
  column-gap: .5rem;
}
.bg-input-button {
  background-color: inherit;
}
</style>
